import React, { useState, useEffect, useContext } from 'react'

import UserProfile from './UserProfile/homepage'
import Wallet from './Wallet'
import classNames from 'classnames'
import Clevertap from 'analytics'
import { DOMAIN_COUNTRY_MAP } from 'constants/flightResults'
import { DOMAIN } from 'constants/base'
import { ReactComponent as CleartripLogo } from 'assets/logos/cleartrip-logo.svg'
import { getWalletInfo } from 'utils/apiHelper.js'
import { getCookie, getUserAuthValues, isEmpty } from 'utils/browserHelper'

import { getCurrenciesApi } from 'api/flights/results'

import { CurrencyContext } from 'context/flights/results'

const GlobalNav = ({ minHeader = false, abTest = {} }) => {
    const isRTL = process.env.CONTENT_DIR === 'RTL'
    const [currencies, setCurrencies] = useContext(CurrencyContext)
    const [signedIn, setSignedIn] = useState(false)
    const [walletBalance, setWalletBalance] = useState('')
    const [walletLoading, setWalletLoading] = useState(true)
    useEffect(() => {
        _getCurrencies()
    }, [])
    const usermisc = getCookie('usermisc') || ''
    const { userId } = getUserAuthValues()
    if (usermisc.includes('SIGNED_IN') && !isEmpty(userId) && !signedIn) {
        setSignedIn(true)
    }

    const fetchWalletInfoAndTransactions = async () => {
        const walletRes = await getWalletInfo(new Date(document.lastModified).getTime())
        const { status: walletResStatus, data: walletData = {} } = walletRes || {}
        if (walletRes?.status === 200) {
            const { balance = 0 } = (walletData?.wallet && walletData?.wallet?.[0]) || {}
            Clevertap.event('wallet_display', {
                wallet_icon_displayed: 'yes',
                wallet_balance: balance
            })
            setWalletBalance(balance)
            setWalletLoading(false)
        } else {
            Clevertap.event('wallet_display', {
                wallet_icon_displayed: 'no',
                wallet_balance: ''
            })
            setWalletBalance('')
            setWalletLoading(false)
        }
    }
    useEffect(() => {
        if (signedIn && DOMAIN_COUNTRY_MAP[DOMAIN] === 'IN') {
            // if (getAbTest && getAbTest.wallet_display && getAbTest.wallet_display === 'b') {
            fetchWalletInfoAndTransactions()
            // }
        }
    }, [])
    const _getCurrencies = async () => {
        try {
            const currenciesResponse = await getCurrenciesApi()
            const { data: currenciesData = '' } = currenciesResponse || ''
            let currenciesObj
            // if (process.env.CT_ENV === 'development') {
            //     currenciesObj = currenciesData
            // } else {
            currenciesObj = currenciesData.split('currencies = ')[1] || {}
            currenciesObj = JSON.parse(currenciesObj)
            // }
            if (!isEmpty(currenciesObj)) {
                setCurrencies({
                    ...currencies,
                    currencyList: currenciesObj
                })
            }
        } catch (e) {
            console.log('Currency api error', e)
        }
    }

    return (
        <div className="flex flex-middle flex-between pt-4 pb-4">
            <div className="flex flex-middle">
                <a data-test-attrib="cleartrip-logo" href="/" className={classNames('', isRTL ? 'ml-6' : 'mr-6')}>
                    <CleartripLogo color="#214497" className={classNames('', isRTL ? 'ml-7' : 'mr-7')} />
                </a>
            </div>
            <div className="flex flex-middle px-1">
                <Wallet abTest={abTest} walletBalance={walletBalance} walletLoading={walletLoading} />
                <UserProfile minHeader={minHeader} abTest={abTest} />
            </div>
        </div>
    )
}
GlobalNav.defaultProps = {
    humbgerShow: true
}

export default GlobalNav
